module.exports = __webpack_public_path__ + "img/DNARepair-CRC_CRLM.e761bf03.png";